import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  public didDesignScrollInitial = false;
  private store = new Map<string, number>();

  getPosition(name: string): number {
    return this.store.get(name) ?? 0;
  }

  savePosition(name: string, position: number): void {
    this.store.set(name, position);
  }

  scrollToPosition(name: string, element: HTMLElement): void {
    const position = this.getPosition(name) ?? 0;
    element.scrollTop = position;
  }
}
